/*
  •	Copyright (c) 2023 Pegasystems Inc.
  •	All rights reserved.
*/
import { from } from 'rxjs';
import { map } from 'rxjs/operators';

import { resolveRestApi } from '../../router/app-router';
import { fetch } from '../../service_broker/fetch';
import * as actionType from '../../store/state/actions';
import { processHeaders } from '../../store/state/epics/util';
import { logAndCatchError } from '../../utils/rxjs-utils';
import type { Headers } from '../../types';

const DXAPI_ERROR = 'Error occurred during ajax call at showData Epic : ';

interface ShowDataPayload {
  context: string;
  pageName?: string;
  dataContext?: string;
  dataContextParameters?: Record<string, unknown>;
  semanticURL?: string;
  skipSemanticUrl?: boolean;
  containerName?: string;
  isDeferLoaded?: boolean;
  parentAction?: string;
  resourceType?: string;
  RemoteSystemID?: string;
}

const executeAsyncRequest = (
  payload: ShowDataPayload,
  options: { removeActionPayload?: Record<string, string | number | boolean> }
) => {
  const { context, pageName, dataContext, dataContextParameters, semanticURL, skipSemanticUrl, RemoteSystemID } =
    payload;
  const { removeActionPayload } = options;
  const {
    restApi: restUrl,
    reqType,
    body
  } = resolveRestApi(actionType.ACTION_SHOWDATA, { pageName, dataContext, dataContextParameters });

  const headers: Headers = {};
  headers.RemoteSystemID = RemoteSystemID;

  return from(
    fetch(
      restUrl,
      {
        method: reqType,
        headers,
        body
      },
      context
    )
  ).pipe(
    map((response) => {
      const responseData = response.data;
      return {
        response: {
          ...responseData,
          key: semanticURL,
          semanticURL
        },
        actionConfig: payload,
        headers: processHeaders(response.headers),
        removeActionPayload,
        skipSemanticUrl
      };
    }),
    logAndCatchError(DXAPI_ERROR, payload.context)
  );
};

export default executeAsyncRequest;
